// extracted by mini-css-extract-plugin
module.exports = {"guildAdmin":"GuildSelector_guildAdmin__wOuOG","guildOwner":"GuildSelector_guildOwner__XxbVE"};